/* global axios */
import ApiClient from './ApiClient';

class RealEstateBrokerInvestmentsAPI extends ApiClient {
  constructor() {
    super('real_estate_broker_investments', { accountScoped: true });
  }

  index(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }
}

export default new RealEstateBrokerInvestmentsAPI();
